/* Moctezuma · tema propio — interacciones (sin librerías) */
(function () {
  'use strict';
  var T = window.mxTema || { rutas: { carrito: '/cart', agregar: '/cart/add' }, carrito: 'notification', textos: {} };
  // Formato de precio en la moneda que ve el cliente: se deduce de una muestra que
  // Shopify ya formateó ({{ 1234567 | money }} → "$ 12,345.67 MXN", "€12.345,67 EUR"…)
  var dinero = function (centavos) {
    var m = String(T.muestraDinero || '$ 12,345.67').match(/^(.*?)12(\D?)345(?:(\D)67)?(.*)$/);
    if (!m) return (centavos / 100).toFixed(2);
    var conDecimales = m[3] !== undefined;
    var partes = (centavos / 100).toFixed(conDecimales ? 2 : 0).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[2] || '');
    return m[1] + partes[0] + (conDecimales ? m[3] + partes[1] : '') + m[4];
  };

  /* ---------- Variantes (producto y tarjetas) ---------- */
  function iniciarSelector(sel) {
    if (sel.dataset.listo) return;
    sel.dataset.listo = '1';
    var json = sel.querySelector('[data-variantes]');
    if (!json) return;
    var variantes = JSON.parse(json.textContent);
    var formId = sel.dataset.form;
    var form = formId ? document.getElementById(formId) : sel.closest('form');
    var raiz = sel.closest('[data-producto]') || sel.closest('[data-tarjeta]') || document;

    function valores() {
      var v = [];
      sel.querySelectorAll('[data-opcion]').forEach(function (el) {
        if (el.type === 'radio') { if (el.checked) v[+el.dataset.opcion] = el.value; }
        else v[+el.dataset.opcion] = el.value;
      });
      return v;
    }

    function marcarDisponibles(actual) {
      sel.querySelectorAll('input[type=radio][data-opcion]').forEach(function (r) {
        var i = +r.dataset.opcion;
        var prueba = actual.slice(); prueba[i] = r.value;
        var hay = variantes.some(function (v) { return v.options.every(function (o, k) { return o === prueba[k]; }) && v.available; });
        r.closest('.mx-chip').classList.toggle('es-agotada', !hay);
      });
    }

    function cambiar() {
      var v = valores();
      var variante = variantes.find(function (x) { return x.options.every(function (o, i) { return o === v[i]; }); });
      sel.querySelectorAll('[data-valor-opcion]').forEach(function (s, i) { s.textContent = v[i] || ''; });
      marcarDisponibles(v);
      var botones = raiz.querySelectorAll('[data-boton-agregar]');
      if (!variante) {
        botones.forEach(function (b) { b.disabled = true; var t = b.querySelector('[data-texto-boton]'); if (t) t.textContent = T.textos.noDisponible || 'No disponible'; });
        return;
      }
      var input = (form || raiz).querySelector('[data-id-variante]');
      if (input) input.value = variante.id;
      botones.forEach(function (b) {
        b.disabled = !variante.available;
        var t = b.querySelector('[data-texto-boton]');
        if (t) { if (!t.dataset.original) t.dataset.original = t.textContent; t.textContent = variante.available ? t.dataset.original.replace(T.textos.agotado, T.textos.agregar) : (T.textos.agotado || 'Agotado'); }
        if (variante.available && t && (t.textContent === T.textos.agotado || t.textContent === T.textos.noDisponible)) t.textContent = T.textos.agregar;
      });
      // precio
      raiz.querySelectorAll('[data-precio]').forEach(function (p) {
        var actual = p.querySelector('.mx-precio__actual');
        var antes = p.querySelector('.mx-precio__antes');
        if (actual) actual.textContent = dinero(variante.price);
        var oferta = variante.compare_at_price && variante.compare_at_price > variante.price;
        p.classList.toggle('mx-precio--oferta', !!oferta);
        if (oferta) {
          if (!antes) { antes = document.createElement('s'); antes.className = 'mx-precio__antes'; p.insertBefore(antes, actual); }
          antes.textContent = dinero(variante.compare_at_price);
        } else if (antes) antes.remove();
      });
      var barra = raiz.querySelector('[data-precio-barra]');
      if (barra) barra.textContent = dinero(variante.price);
      // stock
      var stock = raiz.querySelector('[data-stock]');
      if (stock) {
        var umbral = +stock.dataset.umbral || 5;
        var q = variante.inventory_quantity;
        if (!variante.available) stock.innerHTML = '<span class="mx-stock mx-stock--agotado">' + (T.textos.agotado || 'Agotado') + '</span>';
        else if (variante.inventory_management === 'shopify' && q > 0 && q <= umbral) stock.innerHTML = '<span class="mx-stock mx-stock--poco">' + (T.textos.quedan || '¡Solo quedan [n]!').replace('[n]', q) + '</span>';
        else stock.innerHTML = '<span class="mx-stock"><svg class="mx-icono" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="m7.5 12.2 3 3 6-6.4" fill="none" stroke="#fff" stroke-width="2"/></svg> ' + (T.textos.enStock || '¡En stock!') + '</span>';
      }
      var sku = raiz.querySelector('[data-sku]'); if (sku) sku.textContent = variante.sku || '';
      // características (opciones y peso de la variante)
      raiz.querySelectorAll('[data-car-opcion]').forEach(function (d) { d.textContent = v[+d.dataset.carOpcion] || ''; });
      var peso = raiz.querySelector('[data-car-peso]'); if (peso && variante.weight) peso.textContent = Math.round(variante.weight * 10) / 10 + ' g';
      raiz.dispatchEvent(new CustomEvent('mx:variante', { detail: variante }));
      // imagen
      if (variante.featured_media) mostrarMedia(raiz, variante.featured_media.id);
      // URL (solo en la página de producto)
      if (raiz.dataset && raiz.dataset.url && window.history.replaceState) {
        window.history.replaceState({}, '', raiz.dataset.url + '?variant=' + variante.id);
      }
    }
    sel.addEventListener('change', cambiar);
    marcarDisponibles(valores());
  }

  /* ---------- Galería ---------- */
  function mostrarMedia(raiz, id) {
    var gal = raiz.querySelector('[data-galeria]');
    if (!gal) return;
    var items = gal.querySelectorAll('[data-media-id]');
    var hay = false;
    items.forEach(function (it) { var ok = it.dataset.mediaId == id; it.classList.toggle('es-activa', ok); if (ok) hay = true; });
    if (!hay && items[0]) items[0].classList.add('es-activa');
    gal.querySelectorAll('[data-miniatura]').forEach(function (m) {
      var ok = m.dataset.miniatura == id; m.classList.toggle('es-activa', ok);
      if (ok) m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    gal.querySelectorAll('video').forEach(function (v) { if (!v.closest('.es-activa')) v.pause(); });
  }
  function iniciarGaleria(gal) {
    var raiz = gal.closest('[data-producto]') || gal.parentNode;
    var ids = Array.prototype.map.call(gal.querySelectorAll('[data-media-id]'), function (e) { return e.dataset.mediaId; });
    function actual() { var a = gal.querySelector('.mx-galeria__item.es-activa'); return a ? ids.indexOf(a.dataset.mediaId) : 0; }
    function ir(paso) { if (!ids.length) return; var i = (actual() + paso + ids.length) % ids.length; mostrarMedia(raiz, ids[i]); }
    gal.addEventListener('click', function (e) {
      var m = e.target.closest('[data-miniatura]'); if (m) return mostrarMedia(raiz, m.dataset.miniatura);
      if (e.target.closest('[data-galeria-anterior]')) return ir(-1);
      if (e.target.closest('[data-galeria-siguiente]')) return ir(1);
    });
    // deslizar en celular
    var x0 = null, principal = gal.querySelector('.mx-galeria__principal');
    if (principal) {
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) ir(dx < 0 ? 1 : -1); x0 = null; });
    }
    // zoom al pasar el cursor
    if (window.matchMedia('(hover: hover)').matches) {
      gal.querySelectorAll('.mx-zoom').forEach(function (z) {
        var img = z.querySelector('img'); if (!img) return;
        z.addEventListener('mousemove', function (e) {
          var r = z.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          z.classList.add('es-zoom');
        });
        z.addEventListener('mouseleave', function () { z.classList.remove('es-zoom'); });
      });
    }
  }

  /* ---------- Carrito ---------- */
  function avisar(item, cuenta) {
    var aviso = document.querySelector('[data-aviso-carrito]');
    document.querySelectorAll('[data-contador-carrito]').forEach(function (c) { c.textContent = cuenta; });
    if (!aviso) return;
    var cont = aviso.querySelector('[data-aviso-producto]');
    if (cont && item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '<span></span>';
      var variante = item.variant_title && item.variant_title !== 'Default Title' ? '<p style="opacity:.7;font-size:.85em">' + item.variant_title + '</p>' : '';
      cont.innerHTML = img + '<div><p>' + item.product_title + '</p>' + variante + '<p>' + dinero(item.final_line_price || item.price) + '</p></div>';
    }
    aviso.hidden = false;
    clearTimeout(aviso._t);
    aviso._t = setTimeout(function () { aviso.hidden = true; }, 7000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-form-producto]');
    if (!form) return;
    if (T.carrito === 'page') return; // envío normal → página del carrito
    e.preventDefault();
    // form.id no sirve: el campo oculto name="id" lo tapa
    var idForm = form.getAttribute('id');
    var botones = idForm
      ? document.querySelectorAll('[data-boton-agregar][form="' + idForm + '"], [id="' + idForm + '"] [data-boton-agregar]')
      : form.querySelectorAll('[data-boton-agregar]');
    botones.forEach(function (b) { b.classList.add('es-cargando'); });
    var datos = new FormData(form);
    var cuerpo = datos, cabeceras = { Accept: 'application/json' };
    var gar = idForm && document.querySelector('[data-garantia][data-form="' + idForm + '"]');
    if (gar && gar.dataset.idGarantia && gar.querySelector('[data-garantia-check]').checked) {
      // La pieza y su garantía de recompra se agregan juntas
      var cant = +datos.get('quantity') || 1, props = {};
      props[T.textos.garantiaPieza || 'Pieza'] = gar.dataset.pieza + (gar.dataset.variante ? ' · ' + gar.dataset.variante : '');
      props._pieza = String(datos.get('id'));
      cuerpo = JSON.stringify({ items: [
        { id: +datos.get('id'), quantity: cant },
        { id: +gar.dataset.idGarantia, quantity: cant, properties: props }
      ] });
      cabeceras['Content-Type'] = 'application/json';
    }
    fetch(T.rutas.agregar + '.js', { method: 'POST', headers: cabeceras, body: cuerpo })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j.items ? j.items[0] : j; }); })
      .then(function (item) {
        if (document.querySelector('[data-panel-carrito]')) return refrescarCarro(true);
        return fetch(T.rutas.carrito + '.js').then(function (r) { return r.json(); }).then(function (c) { avisar(item, c.item_count); });
      })
      .catch(function (err) { alert((err && (err.description || err.message)) || T.textos.error); })
      .finally(function () { botones.forEach(function (b) { b.classList.remove('es-cargando'); }); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar-aviso]')) e.target.closest('[data-aviso-carrito]').hidden = true;
  });

  /* ---------- Carrito: panel lateral y página (mismo contenido) ---------- */
  var arreglando = false;
  function contadores(n) {
    document.querySelectorAll('[data-contador-carrito]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  function refrescarCarro(abrir) {
    var carros = document.querySelectorAll('[data-carro]');
    return Promise.all(Array.prototype.map.call(carros, function (c) {
      return fetch(T.rutas.carrito + '?section_id=' + c.dataset.seccion).then(function (r) { return r.text(); }).then(function (html) {
        var n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-carro]');
        if (n) c.replaceWith(document.importNode(n, true));
      });
    })).then(function () {
      return fetch(T.rutas.carrito + '.js').then(function (r) { return r.json(); }).then(function (c) { contadores(c.item_count); });
    }).then(function () {
      iniciarCarros();
      var d = document.querySelector('[data-panel-carrito]');
      if (abrir && d && !d.open) d.showModal();
    });
  }
  function pedirCarro(ruta, cuerpo) {
    document.querySelectorAll('[data-carro]').forEach(function (c) { c.classList.add('es-cargando'); });
    return fetch(ruta, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .catch(function (err) { alert((err && (err.description || err.message)) || T.textos.error); })
      .then(function () { return refrescarCarro(false); });
  }
  function rutaCarro(accion) { return T.rutas.carrito + '/' + accion + '.js'; }
  function iniciarCarros() {
    document.querySelectorAll('[data-carro]').forEach(function (c) {
      if (c.dataset.listo) return; c.dataset.listo = '1';
      var d = c.dataset, tasa = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      // Garantías huérfanas o con otra cantidad que su pieza: se corrigen una vez
      var arr = c.querySelector('[data-carro-arreglos]');
      if (arr && !arreglando) {
        arreglando = true;
        var updates = {}; try { updates = JSON.parse(arr.textContent); } catch (x) {}
        pedirCarro(rutaCarro('update'), { updates: updates }).then(function () { arreglando = false; });
        return;
      }
      // Barra de envío gratis (el monto viene en MXN)
      var env = c.querySelector('[data-carro-envio]');
      if (env && d.meta) {
        var meta = Math.round(+d.meta * tasa * 100), total = +d.total, falta = meta - total;
        env.querySelector('[data-carro-envio-texto]').textContent = falta > 0 ? d.tFaltan.replace('[monto]', dinero(falta)) : d.tGratis;
        env.querySelector('[data-carro-envio-barra]').style.width = Math.min(100, total / meta * 100) + '%';
        env.classList.toggle('es-gratis', falta <= 0);
      }
      // Llegada aproximada con el primer método de la zona
      var llega = c.querySelector('[data-carro-llega]');
      if (llega) {
        var hora = +new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: 'America/Mexico_City' }).format(new Date());
        var sumar = function (f, n, habiles) { f = new Date(f); while (n > 0) { f.setDate(f.getDate() + 1); var w = f.getDay(); if (habiles && (w === 0 || w === 6)) continue; n--; } return f; };
        var inicio = new Date(); if (hora >= +d.corte) inicio.setDate(inicio.getDate() + 1);
        var fines = d.fines === 'true';
        var a = sumar(sumar(inicio, Math.max(+d.procMin - 1, 0), !fines), +d.envA, true);
        var b = sumar(sumar(inicio, Math.max(+d.procMax - 1, 0), !fines), +d.envB, true);
        var fmt = new Intl.DateTimeFormat(d.idioma || 'es', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'America/Mexico_City' });
        var ta = fmt.format(a), tb = fmt.format(b);
        llega.querySelector('span').textContent = d.tLlega.replace('[fecha]', ta === tb ? ta : ta + ' – ' + tb);
        llega.hidden = false;
      }
      var nota = c.querySelector('[data-carro-nota]');
      if (nota) nota.addEventListener('input', function () {
        clearTimeout(nota._t);
        nota._t = setTimeout(function () { fetch(rutaCarro('update'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: nota.value }) }); }, 600);
      });
    });
  }
  function codigosActuales(c) {
    return Array.prototype.map.call(c.querySelectorAll('[data-codigo]'), function (x) { return x.dataset.codigo; });
  }
  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-abrir-carrito]');
    var panel = document.querySelector('[data-panel-carrito]');
    if (abrir && panel && panel.showModal) { e.preventDefault(); panel.showModal(); return; }
    var b = e.target.closest('[data-carro-cambiar]');
    if (b) {
      var up = {}; up[b.dataset.carroCambiar] = +b.dataset.q;
      if (b.dataset.garKey) up[b.dataset.garKey] = +b.dataset.q;
      pedirCarro(rutaCarro('update'), { updates: up });
      return;
    }
    b = e.target.closest('[data-carro-garantia]');
    if (b) {
      var props = {}; props[b.dataset.etiqueta || 'Pieza'] = b.dataset.texto; props._pieza = b.dataset.pieza;
      pedirCarro(rutaCarro('add'), { items: [{ id: +b.dataset.carroGarantia, quantity: +b.dataset.cantidad || 1, properties: props }] });
      return;
    }
    b = e.target.closest('[data-carro-agregar]');
    if (b) { pedirCarro(rutaCarro('add'), { items: [{ id: +b.dataset.carroAgregar, quantity: 1 }] }); return; }
    b = e.target.closest('[data-carro-aplicar]');
    if (b) {
      var c = b.closest('[data-carro]'), campo = c.querySelector('[data-carro-codigo]'), codigo = campo.value.trim();
      if (!codigo) { campo.focus(); return; }
      var lista = codigosActuales(c); if (lista.indexOf(codigo) < 0) lista.push(codigo);
      pedirCarro(rutaCarro('update'), { discount: lista.join(',') }).then(function () {
        // Shopify descarta en silencio los códigos que no existen: avisamos
        var nuevo = document.querySelector('[data-carro]');
        var ok = Array.prototype.some.call(document.querySelectorAll('[data-codigo]'), function (x) { return x.dataset.codigo.toLowerCase() === codigo.toLowerCase(); });
        document.querySelectorAll('[data-carro-aviso]').forEach(function (a) {
          if (ok) return;
          var car = a.closest('[data-carro]');
          a.textContent = codigo + ' · ' + car.dataset.tNoAplica;
          a.hidden = false;
          a.closest('details').open = true;
        });
      });
      return;
    }
    b = e.target.closest('[data-carro-quitar-codigo]');
    if (b) {
      var resto = codigosActuales(b.closest('[data-carro]')).filter(function (x) { return x !== b.dataset.carroQuitarCodigo; });
      pedirCarro(rutaCarro('update'), { discount: resto.join(',') });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-carro-codigo]')) { e.preventDefault(); e.target.closest('[data-carro]').querySelector('[data-carro-aplicar]').click(); }
  });
  document.addEventListener('change', function (e) {
    var env = e.target.closest('[data-carro-envoltura]');
    if (!env) return;
    if (env.checked) pedirCarro(rutaCarro('add'), { items: [{ id: +env.dataset.carroEnvoltura, quantity: 1 }] });
    else { var up = {}; up[env.dataset.key] = 0; pedirCarro(rutaCarro('update'), { updates: up }); }
  });

  /* ---------- Cantidad ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-restar],[data-sumar]');
    if (!b) return;
    var input = b.closest('[data-cantidad]').querySelector('input');
    var min = +input.min || 0;
    var v = (+input.value || 0) + (b.hasAttribute('data-sumar') ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-enviar]')) {
      clearTimeout(window._mxEnvio);
      var f = document.getElementById('FormCarrito');
      window._mxEnvio = setTimeout(function () { if (f) f.submit(); }, 700);
    }
    if (e.target.matches('[data-auto-enviar-form]')) e.target.form.submit();
  });
  document.addEventListener('click', function (e) {
    var pagar = e.target.closest('[data-boton-pagar]');
    if (!pagar) return;
    var t = (pagar.closest('[data-carro]') || document).querySelector('[data-terminos]');
    if (t && !t.checked) { e.preventDefault(); t.focus(); alert(T.textos.aceptaTerminos); }
  });

  /* ---------- Pestañas ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pestana]');
    if (!b) return;
    var cont = b.closest('[data-pestanas]');
    cont.querySelectorAll('[data-pestana]').forEach(function (x) { var ok = x === b; x.classList.toggle('es-activa', ok); x.setAttribute('aria-selected', ok); });
    cont.querySelectorAll(':scope > [data-panel], :scope [role=tabpanel][data-panel]').forEach(function (p) {
      if (p.closest('[data-pestanas]') === cont) p.hidden = p.dataset.panel !== b.dataset.pestana;
    });
  });

  /* ---------- Ventanas (guía de tallas) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-abrir-modal]');
    if (a) { var d = document.getElementById(a.dataset.abrirModal); if (d && d.showModal) d.showModal(); return; }
    var c = e.target.closest('[data-cerrar-modal]');
    if (c) { c.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mx-modal')) e.target.close();
  });

  /* ---------- Filtros de colección ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-abrir-filtros]')) { var f = document.querySelector('[data-filtros]'); if (f) { f.hidden = false; document.body.style.overflow = 'hidden'; } }
    if (e.target.closest('[data-cerrar-filtros]')) { var g = document.querySelector('[data-filtros]'); if (g) { g.hidden = true; document.body.style.overflow = ''; } }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-form-filtros]');
    if (!f) return;
    e.preventDefault();
    var params = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    window.location.href = f.action + '?' + params.toString();
  });

  /* ---------- Ver más ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ver-mas]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('es-cargando');
    fetch(b.href).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nuevas = doc.querySelector('[data-rejilla-productos]');
      var rejilla = document.querySelector('[data-rejilla-productos]');
      if (nuevas && rejilla) Array.prototype.forEach.call(nuevas.children, function (n) { rejilla.appendChild(document.importNode(n, true)); });
      var sig = doc.querySelector('[data-ver-mas]');
      if (sig) { b.href = sig.href; b.classList.remove('es-cargando'); } else b.parentNode.remove();
      iniciar();
    });
  });

  /* ---------- Catálogo: ordenar y vista rápida ---------- */
  document.addEventListener('change', function (e) {
    var o = e.target.closest('[data-orden]');
    if (!o) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', o.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vista-rapida-url]');
    if (!b) return;
    var d = document.querySelector('[data-vista-rapida]');
    if (!d) { window.location.href = b.dataset.vistaRapidaUrl; return; }
    e.preventDefault();
    b.classList.add('es-cargando');
    var url = b.dataset.vistaRapidaUrl + (b.dataset.vistaRapidaUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=vista-rapida';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cuerpo = doc.querySelector('.mx-vc__ficha-cuerpo');
      if (!cuerpo) { window.location.href = b.dataset.vistaRapidaUrl; return; }
      var cont = d.querySelector('[data-vista-rapida-cuerpo]');
      cont.innerHTML = ''; cont.appendChild(document.importNode(cuerpo, true));
      iniciar(); d.showModal();
    }).finally(function () { b.classList.remove('es-cargando'); });
  });

  /* ---------- Barra fija de compra ---------- */
  function iniciarBarra() {
    var barra = document.querySelector('[data-barra-compra]');
    var boton = document.querySelector('.mx-comprar > [data-boton-agregar]');
    if (!barra || !boton || !('IntersectionObserver' in window)) return;
    barra.hidden = false;
    new IntersectionObserver(function (en) {
      var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      barra.classList.toggle('es-visible', fuera);
    }).observe(boton);
  }

  /* ---------- Recomendaciones ---------- */
  function cargarSeccion(cont, url, selector) {
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nuevo = doc.querySelector(selector);
      if (nuevo && nuevo.innerHTML.trim()) { cont.innerHTML = nuevo.innerHTML; iniciar(); }
    }).catch(function () {});
  }

  /* ---------- Garantía de recompra (producto aparte, % del precio) ---------- */
  function iniciarGarantia(g) {
    if (g.dataset.listo) return; g.dataset.listo = '1';
    var vars = JSON.parse(g.querySelector('[data-garantia-variantes]').textContent || '[]');
    var pct = (+g.dataset.pct || 35) / 100, monto = g.querySelector('[data-garantia-monto]');
    function calcular(precio, titulo) {
      var meta = precio * pct, mejor = null;
      vars.forEach(function (x) { if (!mejor || Math.abs(x.p - meta) < Math.abs(mejor.p - meta)) mejor = x; });
      g.hidden = !mejor || !precio;
      if (!mejor) return;
      g.dataset.idGarantia = mejor.id;
      if (titulo !== undefined) g.dataset.variante = titulo;
      monto.textContent = dinero(mejor.p);
    }
    calcular(+g.dataset.precio);
    var raiz = g.closest('[data-producto]');
    if (raiz) raiz.addEventListener('mx:variante', function (e) { calcular(e.detail.price, e.detail.title); });
  }

  /* ---------- Línea de entrega: se procesa → se envía → llega ---------- */
  function iniciarEntrega(el) {
    if (el.dataset.listo) return; el.dataset.listo = '1';
    var zonas = []; try { zonas = JSON.parse(el.querySelector('[data-zonas]').textContent); } catch (x) {}
    if (!zonas.length) { el.hidden = true; return; }
    var d = el.dataset, tasa = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
    var precio = +d.precio || 0, zi = 0, mi = 0;
    zonas.forEach(function (z, i) { if ((z.p || []).indexOf(d.pais) > -1) zi = i; });
    var sel = el.querySelector('[data-ent-zona]'), lista = el.querySelector('[data-ent-metodos]');
    zonas.forEach(function (z, i) { var o = document.createElement('option'); o.value = i; o.textContent = z.n; sel.appendChild(o); });
    sel.value = zi;
    var idioma = d.idioma || 'es';
    var fmt = new Intl.DateTimeFormat(idioma, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'America/Mexico_City' });
    function rango(a, b, habiles) {
      if (a === b && a === 1) return habiles ? d.tDiaHabil : d.tDia;
      return (habiles ? d.tRangoHabiles : d.tRango).replace('[a]', a).replace('[b]', b);
    }
    function sumar(f, n, habiles) {
      f = new Date(f);
      while (n > 0) { f.setDate(f.getDate() + 1); var w = f.getDay(); if (habiles && (w === 0 || w === 6)) continue; n--; }
      return f;
    }
    function horaMx() { return +new Intl.DateTimeFormat('en-US', { hour: 'numeric', hourCycle: 'h23', timeZone: 'America/Mexico_City' }).format(new Date()); }
    function gratis(m) { return m.g !== null && m.g !== undefined && precio >= m.g * tasa * 100; }
    function costo(m) { return gratis(m) || !m.c ? d.tGratis : dinero(Math.round(m.c * tasa * 100)); }
    function pintar() {
      var z = zonas[zi], m = z.m[mi] || z.m[0];
      if (!m) return;
      var corte = +d.corte, antes = horaMx() < corte, fines = d.fines === 'true';
      var inicio = new Date(); if (!antes) inicio.setDate(inicio.getDate() + 1);
      var pMin = +d.procMin, pMax = +d.procMax;
      // el día de inicio cuenta como el primer día de proceso
      var listoMin = sumar(inicio, Math.max(pMin - 1, 0), !fines), listoMax = sumar(inicio, Math.max(pMax - 1, 0), !fines);
      var llegaMin = sumar(listoMin, m.a, true), llegaMax = sumar(listoMax, m.b, true);
      el.querySelector('[data-ent-proc]').textContent = rango(pMin, pMax, false);
      el.querySelector('[data-ent-envio]').textContent = m.n + ' · ' + costo(m);
      var a = fmt.format(llegaMin), b = fmt.format(llegaMax);
      el.querySelector('[data-ent-llega]').textContent = a === b ? a : a + ' – ' + b;
      el.querySelector('[data-ent-corte]').hidden = !antes;
      lista.innerHTML = '';
      z.m.forEach(function (x, i) {
        var lab = document.createElement('label'); lab.className = 'mx-entrega__metodo' + (i === mi ? ' es-activo' : '');
        var extra = !gratis(x) && x.g ? '<small>' + d.tGratisDesde.replace('[monto]', dinero(Math.round(x.g * tasa * 100))) + '</small>' : '';
        lab.innerHTML = '<input type="radio" name="ent-metodo" value="' + i + '"' + (i === mi ? ' checked' : '') + '>' +
          '<span class="mx-entrega__metodo-nombre">' + x.n + '<small>' + rango(x.a, x.b, true) + '</small></span>' +
          '<span class="mx-entrega__metodo-precio">' + costo(x) + extra + '</span>';
        lista.appendChild(lab);
      });
    }
    sel.addEventListener('change', function () { zi = +sel.value; mi = 0; pintar(); });
    lista.addEventListener('change', function (e) { mi = +e.target.value; pintar(); });
    var abrir = el.querySelector('[data-ent-abrir]'), panel = el.querySelector('[data-ent-panel]');
    abrir.addEventListener('click', function () { panel.hidden = !panel.hidden; abrir.setAttribute('aria-expanded', !panel.hidden); el.classList.toggle('es-abierta', !panel.hidden); });
    var raiz = el.closest('[data-producto]');
    if (raiz) raiz.addEventListener('mx:variante', function (e) { precio = e.detail.price; pintar(); });
    pintar();
  }

  /* ---------- Calculadora de recompra (simulación ligada al precio de la variante) ---------- */
  function iniciarCalc(el) {
    if (el.dataset.listo) return; el.dataset.listo = '1';
    var d = el.dataset, tasa = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
    var filas = el.querySelector('[data-calc-filas]');
    function pct(x) { return (+x || 0) / 100; }
    function pintar(precio) {
      var metal = precio / (+d.mult || 10);
      var garantia = Math.round(precio * pct(d.garantia));
      var artesanal = Math.max(precio * pct(d.artesanal) - metal + garantia, 0);
      var pagado = precio + garantia, apre = pct(d.apreciacion), anual = pct(d.anual), tope = pct(d.tope);
      var anioSin = +d.anioSin || 5, extra = pct(d.extra);
      el.querySelector('[data-calc-pieza]').textContent = dinero(precio);
      el.querySelector('[data-calc-garantia]').textContent = '+' + dinero(garantia);
      var pg = +d.precioG, gramos = pg > 0 ? (metal / tasa / 100) / pg : 0;
      el.querySelector('[data-calc-metal]').innerHTML = dinero(Math.round(metal)) + (gramos ? ' <small>' + d.tGramos.replace('[g]', gramos.toFixed(1)) + '</small>' : '');
      var anios = [1, 2, 3, 4, 5]; var fin = +d.anioFinal || 10; if (anios.indexOf(fin) < 0) anios.push(fin);
      filas.innerHTML = anios.map(function (n) {
        var metalN = metal * Math.pow(1 + apre, n);
        var con = Math.round(metalN + Math.min(n * anual, tope) * artesanal);
        var sin = n >= anioSin ? dinero(Math.round(metalN * (1 + extra))) : '<small>' + d.tFabricacion + '</small>';
        return '<tr><th>' + d.tAnio + ' ' + n + '</th><td><strong>' + dinero(con) + '</strong><small>' + d.tDePagado.replace('[p]', Math.round(con / pagado * 100)) + '</small></td><td>' + sin + '</td></tr>';
      }).join('');
    }
    pintar(+d.precio);
    var raiz = el.closest('[data-producto]');
    if (raiz) raiz.addEventListener('mx:variante', function (e) { pintar(e.detail.price); });
  }

  function iniciar() {
    iniciarCarros();
    iniciarMateriales();
    document.querySelectorAll('[data-calc]').forEach(iniciarCalc);
    document.querySelectorAll('[data-garantia]').forEach(iniciarGarantia);
    document.querySelectorAll('[data-entrega]').forEach(iniciarEntrega);
    document.querySelectorAll('[data-selector-variantes]').forEach(iniciarSelector);
    document.querySelectorAll('[data-galeria]').forEach(function (g) { if (!g.dataset.listo) { g.dataset.listo = '1'; iniciarGaleria(g); } });
  }

  document.addEventListener('DOMContentLoaded', function () {
    iniciar();
    iniciarBarra();
    document.querySelectorAll('[data-recomendaciones-url]').forEach(function (s) {
      if (!s.children.length) cargarSeccion(s, s.dataset.recomendacionesUrl, '[data-recomendaciones-url]');
    });
    document.querySelectorAll('[data-complementarios-url]').forEach(function (s) {
      var dentro = s.querySelector('[data-complementarios]');
      if (dentro && !dentro.children.length) cargarSeccion(dentro, s.dataset.complementariosUrl, '[data-complementarios]');
    });
    // Acordeón del pie: abierto en escritorio
    if (window.matchMedia('(min-width: 750px)').matches) document.querySelectorAll('[data-acordeon-pie]').forEach(function (d) { d.open = true; });
  });
  /* ---------- Suscripción: correo o WhatsApp (ambos opcionales, al menos uno) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-sus-cliente]');
    if (!f) return;
    var caja = f.closest('[data-suscripcion]');
    var correo = (f.querySelector('[data-sus-correo]') || {}).value || '';
    var wa = (f.querySelector('[data-sus-whatsapp]') || {}).value || '';
    var aviso = caja.querySelector('[data-sus-aviso]');
    if (!correo.trim() && !wa.trim()) { e.preventDefault(); if (aviso) aviso.hidden = false; return; }
    if (aviso) aviso.hidden = true;
    try { localStorage.setItem('mx_suscrito', '1'); } catch (x) {}
    if (!correo.trim()) {
      // Solo WhatsApp: se envía por el formulario de contacto sin salir de la página
      e.preventDefault();
      var c = caja.querySelector('[data-sus-contacto]');
      c.querySelector('[data-sus-telefono]').value = wa.trim();
      fetch(c.action, { method: 'POST', body: new FormData(c) }).finally(function () {
        f.hidden = true; var ok = caja.querySelector('[data-sus-ok]'); if (ok) ok.hidden = false;
      });
    }
  });

  /* ---------- Contacto: el formulario abre WhatsApp con el mensaje escrito ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-form-whatsapp]');
    if (!f) return;
    e.preventDefault();
    var valor = function (sel) { return ((f.querySelector(sel) || {}).value || '').trim(); };
    var texto = (f.dataset.plantilla || '[mensaje]')
      .replace('[nombre]', valor('[data-wa-nombre]'))
      .replace('[tema]', valor('[data-wa-tema]'))
      .replace('[mensaje]', valor('[data-wa-mensaje]'));
    window.open('https://wa.me/' + f.dataset.numero + '?text=' + encodeURIComponent(texto), '_blank', 'noopener');
  });

  /* ---------- Materiales: la tarjeta gira, abre su ficha y las láminas pasan solas ---------- */
  function cargarModelo3D() {
    if (!document.querySelector('model-viewer') || window.customElements.get('model-viewer') || document.getElementById('mx-model-viewer')) return;
    var sc = document.createElement('script');
    sc.type = 'module'; sc.id = 'mx-model-viewer';
    sc.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(sc);
  }
  function iniciarLaminas(d) {
    var cont = d.querySelector('[data-mat-laminas]'), puntos = d.querySelector('[data-mat-puntos]');
    if (!cont) return;
    var laminas = cont.querySelectorAll('[data-mat-lamina]');
    var seccion = d.closest('[data-materiales]');
    var ms = ((seccion && +seccion.dataset.segundos) || 3) * 1000;
    var activo = 0, pausa = 0;
    var ir = function (i) { var l = laminas[i]; if (l) cont.scrollTo({ left: l.offsetLeft - cont.offsetLeft, behavior: 'smooth' }); };
    if (puntos) {
      puntos.innerHTML = '';
      if (laminas.length > 1) laminas.forEach(function (l, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', function () { pausa = Date.now() + 6000; ir(i); });
        puntos.appendChild(b);
      });
    }
    var marcar = function () {
      var x = cont.scrollLeft, mejor = 0, dist = Infinity;
      laminas.forEach(function (l, i) { var dd = Math.abs(l.offsetLeft - cont.offsetLeft - x); if (dd < dist) { dist = dd; mejor = i; } });
      activo = mejor;
      if (puntos) puntos.querySelectorAll('button').forEach(function (b, i) { b.classList.toggle('es-activo', i === activo); });
    };
    if (!cont.dataset.listo) {
      cont.dataset.listo = '1';
      cont.addEventListener('scroll', function () { clearTimeout(cont._t); cont._t = setTimeout(marcar, 80); }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { cont.addEventListener(ev, function () { pausa = Date.now() + 6000; }, { passive: true }); });
      cont.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) pausa = Infinity; });
      cont.addEventListener('mouseleave', function () { pausa = 0; });
    }
    cont.scrollLeft = 0; marcar();
    clearInterval(d._auto);
    if (laminas.length > 1) d._auto = setInterval(function () {
      if (!d.open || Date.now() < pausa) return;
      ir((activo + 1) % laminas.length);
    }, ms);
  }
  function abrirMaterial(m, girar) {
    var d = m && m.querySelector('[data-mat-ficha]');
    if (!d || d.open) return;
    if (!d.dataset.listo) {
      d.dataset.listo = '1';
      d.addEventListener('close', function () { clearInterval(d._auto); m.classList.remove('esta-girando'); });
    }
    var abrir = function () { d.showModal(); iniciarLaminas(d); };
    if (girar && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { m.classList.add('esta-girando'); setTimeout(abrir, 380); }
    else abrir();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mat-abrir]');
    if (t) abrirMaterial(t.closest('[data-mat]'), true);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var m = e.target.closest && e.target.closest('[data-mat]');
    if (m && e.target.matches('[data-mat-lamina]')) abrirMaterial(m, false);
  });
  function iniciarMateriales() {
    if (!document.querySelector('[data-materiales]')) return;
    cargarModelo3D();
    var id = decodeURIComponent(location.hash.slice(1));
    var m = id && document.getElementById(id);
    if (m && m.matches('[data-mat]') && !iniciarMateriales.hecho) {
      iniciarMateriales.hecho = true;
      m.scrollIntoView({ block: 'center' });
      setTimeout(function () { abrirMaterial(m, true); }, 300);
    }
  }

  /* ---------- Copiar al portapapeles (enlace del artículo) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copiar]');
    if (!b) return;
    if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copiar);
    var t = b.querySelector('span');
    if (t && b.dataset.copiado) { var antes = t.textContent; t.textContent = b.dataset.copiado; setTimeout(function () { t.textContent = antes; }, 1800); }
  });

  /* ---------- Ventana emergente de suscripción ---------- */
  function iniciarVentanaSus() {
    var d = document.querySelector('[data-ventana-sus]');
    if (!d || !d.showModal) return;
    var frec = d.dataset.frecuencia, clave = 'mx_ventana_sus', hoy = new Date().toISOString().slice(0, 10);
    try {
      if (localStorage.getItem('mx_suscrito')) return;
      if (frec === 'sesion' && sessionStorage.getItem(clave)) return;
      if (frec === 'dia' && localStorage.getItem(clave) === hoy) return;
    } catch (x) {}
    var abierta = false;
    function abrir() {
      if (abierta || document.querySelector('dialog[open]')) return;
      abierta = true; d.showModal();
      try { sessionStorage.setItem(clave, '1'); localStorage.setItem(clave, hoy); } catch (x) {}
    }
    if (d.dataset.modo === 'scroll') {
      var pct = +d.dataset.porcentaje || 50;
      window.addEventListener('scroll', function onS() {
        var h = document.documentElement.scrollHeight - innerHeight;
        if (h > 0 && scrollY / h * 100 >= pct) { window.removeEventListener('scroll', onS); abrir(); }
      }, { passive: true });
    } else {
      setTimeout(abrir, (+d.dataset.segundos || 5) * 1000);
    }
  }
  document.addEventListener('DOMContentLoaded', iniciarVentanaSus);
  document.addEventListener('shopify:section:load', iniciar);
})();
